import { FC, ReactNode } from "react";
import { Outlet } from "react-router-dom";
import CustomMultipleSessionPopUp from "../../components/CustomMultipleSessionPopUp/CustomMultipleSessionPopUp";
import CustomBlockUserPopup from "../../components/CustomBlockUserPopup/CustomBlockUserPopup";
import useAuthGuardBootstrap from "./useAuthGuardBootstrap";

type T_AuthGuardProps = {
  showCustomLoading?: boolean;
  initFlag?: boolean;
  resultCallback?: (authPassed: boolean) => void;
  fallbackUi?: ReactNode;
};

const AuthGuard: FC<T_AuthGuardProps> = ({
  showCustomLoading = false,
  initFlag = true,
  resultCallback,
  fallbackUi = null,
}) => {
  const {
    authPassed,
    showGuardFallback,
    popupError,
    showPopup,
    openBlockedUserPopup,
    logoutPreviousSession,
    handleBlockedUserPopupClose,
    triggerUserLogout,
  } = useAuthGuardBootstrap({
    showCustomLoading,
    initFlag,
  });

  if (resultCallback) {
    resultCallback(authPassed);
  }

  return (
    <>
      {popupError && (
        <CustomMultipleSessionPopUp
          gotoLogin={triggerUserLogout}
          logoutPreviousSession={() => logoutPreviousSession()}
          open={showPopup}
        />
      )}
      {showGuardFallback ? <></> : fallbackUi ? fallbackUi : <Outlet />}
      {openBlockedUserPopup && (
        <CustomBlockUserPopup
          open={openBlockedUserPopup}
          handleOpen={handleBlockedUserPopupClose}
        />
      )}
    </>
  );
};

export default AuthGuard;
